// CourseCard.jsx
import React from 'react';
import './CourseCard.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const CourseCard = ({ id, image, title, subtitle, instructor, duration, certificate, completionPercentage, score }) => {
  const navigate = useNavigate()

  const handleRedirect = (id) => {
    navigate(`${id}`)
  }

  const renderCourseButton = (completionPercentage = 0, id, score) => {
    if (completionPercentage === 0) {
      return (
        <button
          className="custom-btn"
          // style={{ backgroundColor: '#5c4b3b', color: '#fff' }}
          onClick={() => handleRedirect(id)}
        >
          Start Course
        </button>
      );
    } else if (completionPercentage > 0 && completionPercentage < 100) {
      return (
        <button
          className="custom-btn"
          style={{ backgroundColor: '#ffbf00', color: '#000' }} // amber
          onClick={() => handleRedirect(id)}
        >
          In Progress
        </button>
      );
    } else if (completionPercentage === 100) {
      return (
        <button
          className="custom-btn"
          style={{ backgroundColor: '#4caf50', color: '#fff' }}
          // onClick={() => navigate(`/staff/certificate/${id}`)}
          onClick={() => {
            if (score >= 80) {
              navigate(`/staff/certificate/${id}`);
            } else {
              // navigate(`/staff/certificate/${id}`);
              toast.error('Certificate only viewable for score 80+');
            }
          }}
        >
          View Certificate
        </button>
      );
    } else {
      return null; // fallback (optional)
    }
  };

  return (
    <div className="custom-card shadow-sm rounded-4 overflow-hidden h-100 p-2">
      <img src={`${process.env.REACT_APP_BUCKET_URL}${image}`} className="card-img-top" alt={title} />
      <div className="p-3">
        <h5 className="fw-bold mb-0">{title}</h5>
        <small className="text-muted">{subtitle}</small>
        <ul className="list-unstyled mt-2 mb-3 text-muted small">
          <li><i className="bi bi-person me-2"></i>{instructor?.fullName}</li>
          <li>
            <i className="bi bi-clock me-2"></i>
            {Number(duration) < 1
              ? `${(Number(duration) * 60).toFixed(0)} Seconds`
              : `${Number(duration).toFixed(2)} Minutes`}
          </li>
          {/* <li><i className="bi bi-clock me-2"></i>{Number(duration).toFixed(2)} Minutes</li> */}
          <li><i className="bi bi-award me-2"></i>certificate</li>
        </ul>
        <div className="d-flex justify-content-between align-items-center">
          {/* <button className=" custom-btn" onClick={() => handleRedirect(id)}>Start Course</button> */}
          {renderCourseButton(completionPercentage, id, score)}
          <i className="bi bi-arrow-right-circle fs-5 text-muted" onClick={() => handleRedirect(id)}></i>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
